import { createContext } from 'react'

import { CaptchaContextType } from './CaptchaContext.types'

// A default value, not `undefined`, so a tree without the controller still works.
export const CaptchaContext = createContext<CaptchaContextType>({
  isEnabled: false,
  getToken: async () => undefined,
  reset: () => undefined
})
